import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHsCodesRequest, IHsCodesResponse, THsCodesStore } from './types';

const initialState: THsCodesStore = {
	hscodes: null,
	hscodesLoading: false,
	manualHsCodes: null,
	manualHsCodesLoading: false,
};

const hscodes = createSlice({
	name: '@hscodes',
	initialState,
	reducers: {
		getHsCodesRequest: (state, action: PayloadAction<IHsCodesRequest>) => {
			const hscodesState = state;
			hscodesState.hscodesLoading = true;
		},
		getHsCodesSuccess: (state, action: PayloadAction<IHsCodesResponse>) => {
			const hscodesState = state;
			hscodesState.hscodes = action.payload;
			hscodesState.hscodesLoading = false;
		},
		getHsCodesFailure: (state, action: PayloadAction<string>) => {
			const hscodesState = state;
			hscodesState.hscodesLoading = false;
		},
		clearHsCodes: (state) => {
			const hscodesState = state;
			hscodesState.hscodes = null;
			hscodesState.hscodesLoading = false;
		},
		getManualHsCodesRequest: (state, action: PayloadAction<number>) => {
			const hscodesState = state;
			hscodesState.manualHsCodesLoading = true;
		},
		getManualHsCodesSuccess: (state, action: PayloadAction<IHsCodesResponse>) => {
			const hscodesState = state;
			hscodesState.manualHsCodes = action.payload;
			hscodesState.manualHsCodesLoading = false;
		},
		getManualHsCodesFailure: (state, action: PayloadAction<string>) => {
			const hscodesState = state;
			hscodesState.manualHsCodesLoading = false;
		},
		clearManualHsCodes: (state) => {
			const hscodesState = state;
			hscodesState.manualHsCodes = null;
			hscodesState.manualHsCodesLoading = false;
		},
	},
});

export const {
	getHsCodesRequest,
	getHsCodesSuccess,
	getHsCodesFailure,
	clearHsCodes,
	getManualHsCodesRequest,
	getManualHsCodesSuccess,
	getManualHsCodesFailure,
	clearManualHsCodes,
} = hscodes.actions;

export default hscodes.reducer;
